<template>
	<div class="goods-detail">
		<div data-v-eea730d8="" class="search_bread" style="border-bottom: 1px solid rgb(239 239 244 / 0%); padding: 0px 10px 15px 10px; "><a data-v-eea730d8="" href="/web/" class="router-link-active">หน้าแรก</a><span data-v-eea730d8="" class="padd-10">&gt;</span>
		
		<router-link :to="{ path: '/list', query: { category_id: c1} }">{{catewords}}</router-link>
	
		
		<span data-v-eea730d8="" class="padd-10">&gt;</span> <a class="router-link-exact-active router-link-active" style="    font-weight: 600;">{{ goodsSkuDetail.sku_name }}</a> <!----><!----></div>
		<div class="preview-wrap">
			<div class="video-player-wrap" :class="{ show: switchMedia == 'video' }" v-if="goodsSkuDetail.video_url != ''">
				<video-player v-if="goodsSkuDetail.video_url != ''" ref="videoPlayer" :playsinline="true" :options="playerOptions"
				 @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" @ended="onPlayerEnded($event)" @waiting="onPlayerWaiting($event)"
				 @playing="onPlayerPlaying($event)" @loadeddata="onPlayerLoadeddata($event)" @timeupdate="onPlayerTimeupdate($event)"
				 @canplay="onPlayerCanplay($event)" @canplaythrough="onPlayerCanplaythrough($event)" @statechanged="playerStateChanged($event)"
				 @ready="playerReadied"></video-player>

				<div class="media-mode" v-if="goodsSkuDetail.video_url != ''">
					<span :class="{ 'ns-bg-color': switchMedia == 'video' }" @click="switchMedia = 'video'">วีดีโอ</span>
					<span :class="{ 'ns-bg-color': switchMedia == 'img' }" @click="switchMedia = 'img'">ภาพ</span>
				</div>
			</div>
			<!-- , { size: 'big' } -->
			<div class="magnifier-wrap">
				<pic-zoom ref="PicZoom" :url="$img(picZoomUrl)" :scale="2"></pic-zoom>
				
			</div>

			<div class="spec-items">
				<span class="left-btn iconfont icon-arrow-left-copy" :class="{ move: moveThumbLeft }" @click="changeThumbImg('prev')"></span>
				<span class="right-btn iconfont icon-arrow-right" :class="{ move: moveThumbRight }" @click="changeThumbImg('next')"></span>
				<ul :style="{ left: 16 + thumbPosition + 'px' }">
					<!-- รูปขนาดย่อของผลิตภัณฑ์ -->
					<li v-for="(item, index) in goodsSkuDetail.sku_images" :key="index" v-if="item" @mousemove="picZoomUrl = item" :class="{ selected: picZoomUrl == item }">
						<img v-if="item" :src="$img(item, { size: 'small' })" @error="imageErrorSpec(index)" />
						<img v-else :src="'https://hyderabadhouse.net/wp-content/uploads/blank-00cc00.png'" @error="imageErrorSpec(index)" />
					</li>
				</ul>
			</div>

			<div class="share-collect">
				<div @click="editCollection">
					<i class="iconfont" :class="whetherCollection == 1 ? 'iconlikefill ns-text-color' : 'iconlike'"></i>
					<span data-collects="0">ชืนชอบ（{{ goodsSkuDetail.collect_num }}）</span>
				</div>
				<div v-if="kefuConfig.system == 0 && kefuConfig.open_pc == 1">
					<i class="iconfont iconzhanghao"></i>
					<span data-collects="0"><a :href="kefuConfig.open_url" target="_blank">ติดต่อฝ่ายบริการลูกค้า</a></span>
				</div>
				<div @click="service_link" v-else-if="kefuConfig.system == 1">
					<i class="iconfont iconzhanghao"></i>
					<span data-collects="0">ติดต่อฝ่ายบริการลูกค้า</span>
				</div>
			</div>
		</div>

		<!-- ข้อมูลผลิตภัณฑ์ -->
		<div class="basic-info-wrap" v-loading="loading">
			<h1>{{ goodsSkuDetail.sku_name }}</h1>
			<p class="desc ns-text-color" v-if="goodsSkuDetail.introduction">{{ goodsSkuDetail.introduction }}</p>

		
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			<div class="hO9GFq"  v-if="goodsSkuDetail.promotion_type == 1 && discountTimeMachine.currentTime && addonIsExit.discount" >
				
				
			<svg width="204" zoomAndPan="magnify" viewBox="0 0 153 30.000001" height="40" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><g/></defs><g fill="#ffffff" fill-opacity="1"><g transform="translate(5.370965, 22.137099)"><g><path d="M 5.09375 0.234375 C 3.75 0.234375 2.710938 -0.0820312 1.984375 -0.71875 C 1.265625 -1.363281 0.90625 -2.257812 0.90625 -3.40625 C 0.90625 -4.65625 1.351562 -5.648438 2.25 -6.390625 C 3.144531 -7.140625 4.5625 -7.59375 6.5 -7.75 L 8.921875 -7.9375 L 8.921875 -8.3125 C 8.921875 -9.0625 8.71875 -9.597656 8.3125 -9.921875 C 7.90625 -10.253906 7.285156 -10.421875 6.453125 -10.421875 C 5.640625 -10.421875 4.847656 -10.296875 4.078125 -10.046875 C 3.304688 -9.804688 2.640625 -9.523438 2.078125 -9.203125 L 2.078125 -12.09375 C 2.523438 -12.3125 3.160156 -12.535156 3.984375 -12.765625 C 4.816406 -12.992188 5.78125 -13.109375 6.875 -13.109375 C 7.925781 -13.109375 8.863281 -12.953125 9.6875 -12.640625 C 10.519531 -12.335938 11.171875 -11.828125 11.640625 -11.109375 C 12.117188 -10.398438 12.359375 -9.421875 12.359375 -8.171875 L 12.359375 0 L 8.921875 0 L 8.921875 -5.421875 L 6.890625 -5.203125 C 5.953125 -5.109375 5.300781 -4.921875 4.9375 -4.640625 C 4.570312 -4.367188 4.390625 -4 4.390625 -3.53125 C 4.390625 -3.0625 4.535156 -2.707031 4.828125 -2.46875 C 5.128906 -2.238281 5.53125 -2.125 6.03125 -2.125 C 6.21875 -2.125 6.40625 -2.144531 6.59375 -2.1875 C 6.78125 -2.226562 6.945312 -2.269531 7.09375 -2.3125 L 7.40625 -0.109375 C 7.113281 -0.00390625 6.765625 0.078125 6.359375 0.140625 C 5.953125 0.203125 5.53125 0.234375 5.09375 0.234375 Z M 5.09375 0.234375 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(21.390506, 22.137099)"><g><path d="M 6.234375 0.234375 C 4.972656 0.234375 3.96875 -0.0390625 3.21875 -0.59375 C 2.476562 -1.144531 1.941406 -1.90625 1.609375 -2.875 C 1.285156 -3.851562 1.125 -4.972656 1.125 -6.234375 C 1.125 -7.585938 1.273438 -8.710938 1.578125 -9.609375 C 1.878906 -10.503906 2.3125 -11.203125 2.875 -11.703125 C 3.4375 -12.210938 4.101562 -12.570312 4.875 -12.78125 C 5.644531 -13 6.488281 -13.109375 7.40625 -13.109375 C 8.789062 -13.109375 9.90625 -12.910156 10.75 -12.515625 C 11.601562 -12.128906 12.21875 -11.578125 12.59375 -10.859375 C 12.976562 -10.140625 13.171875 -9.300781 13.171875 -8.34375 L 13.171875 0 L 9.671875 0 L 9.671875 -8.0625 C 9.671875 -8.789062 9.492188 -9.34375 9.140625 -9.71875 C 8.796875 -10.101562 8.21875 -10.296875 7.40625 -10.296875 C 6.863281 -10.296875 6.382812 -10.179688 5.96875 -9.953125 C 5.550781 -9.734375 5.226562 -9.332031 5 -8.75 C 4.78125 -8.175781 4.671875 -7.351562 4.671875 -6.28125 C 4.671875 -5.175781 4.832031 -4.28125 5.15625 -3.59375 C 5.488281 -2.90625 6.0625 -2.5625 6.875 -2.5625 C 7.207031 -2.5625 7.515625 -2.601562 7.796875 -2.6875 L 8.125 -0.0625 C 7.875 0.0390625 7.570312 0.113281 7.21875 0.15625 C 6.875 0.207031 6.546875 0.234375 6.234375 0.234375 Z M 6.234375 0.234375 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(38.227309, 22.137099)"><g><path d="M 6.03125 0.296875 C 5.113281 0.296875 4.191406 0.195312 3.265625 0 C 2.335938 -0.195312 1.515625 -0.484375 0.796875 -0.859375 L 1.78125 -3.640625 C 2.238281 -3.390625 2.832031 -3.128906 3.5625 -2.859375 C 4.300781 -2.585938 5.078125 -2.453125 5.890625 -2.453125 C 7.148438 -2.453125 7.78125 -2.816406 7.78125 -3.546875 C 7.78125 -3.953125 7.539062 -4.265625 7.0625 -4.484375 C 6.59375 -4.710938 5.9375 -4.976562 5.09375 -5.28125 C 4.269531 -5.5625 3.5625 -5.875 2.96875 -6.21875 C 2.375 -6.5625 1.914062 -6.976562 1.59375 -7.46875 C 1.28125 -7.96875 1.125 -8.597656 1.125 -9.359375 C 1.125 -10.640625 1.601562 -11.582031 2.5625 -12.1875 C 3.519531 -12.800781 4.800781 -13.109375 6.40625 -13.109375 C 7.269531 -13.109375 8.050781 -13.03125 8.75 -12.875 C 9.457031 -12.726562 10.003906 -12.554688 10.390625 -12.359375 L 10.390625 -9.59375 C 9.984375 -9.78125 9.410156 -9.960938 8.671875 -10.140625 C 7.929688 -10.328125 7.226562 -10.421875 6.5625 -10.421875 C 5.269531 -10.421875 4.625 -10.09375 4.625 -9.4375 C 4.625 -9.0625 4.875 -8.769531 5.375 -8.5625 C 5.882812 -8.351562 6.597656 -8.09375 7.515625 -7.78125 C 8.734375 -7.351562 9.664062 -6.84375 10.3125 -6.25 C 10.957031 -5.664062 11.28125 -4.828125 11.28125 -3.734375 C 11.28125 -3.035156 11.117188 -2.378906 10.796875 -1.765625 C 10.484375 -1.148438 9.941406 -0.648438 9.171875 -0.265625 C 8.410156 0.109375 7.363281 0.296875 6.03125 0.296875 Z M 6.03125 0.296875 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(52.355453, 22.137099)"><g><path d="M 5.015625 0 L 5.015625 -8.453125 C 5.015625 -9.109375 4.863281 -9.582031 4.5625 -9.875 C 4.257812 -10.175781 3.765625 -10.328125 3.078125 -10.328125 C 2.566406 -10.328125 2.097656 -10.253906 1.671875 -10.109375 C 1.242188 -9.972656 0.84375 -9.800781 0.46875 -9.59375 L 0.46875 -12.40625 C 0.8125 -12.5625 1.289062 -12.71875 1.90625 -12.875 C 2.53125 -13.03125 3.265625 -13.109375 4.109375 -13.109375 C 4.960938 -13.109375 5.71875 -12.984375 6.375 -12.734375 C 7.039062 -12.484375 7.566406 -12.066406 7.953125 -11.484375 C 8.335938 -10.898438 8.53125 -10.101562 8.53125 -9.09375 L 8.53125 0 Z M 5.015625 0 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(64.545493, 22.137099)"><g><path d="M 1.640625 0 L 1.640625 -7.59375 C 1.640625 -9.382812 2.113281 -10.75 3.0625 -11.6875 C 4.007812 -12.632812 5.507812 -13.109375 7.5625 -13.109375 C 9.632812 -13.109375 11.132812 -12.632812 12.0625 -11.6875 C 12.988281 -10.75 13.453125 -9.382812 13.453125 -7.59375 L 13.453125 0 L 9.96875 0 L 9.96875 -7.640625 C 9.96875 -8.460938 9.773438 -9.109375 9.390625 -9.578125 C 9.015625 -10.054688 8.390625 -10.296875 7.515625 -10.296875 C 6.660156 -10.296875 6.039062 -10.054688 5.65625 -9.578125 C 5.28125 -9.109375 5.09375 -8.460938 5.09375 -7.640625 L 5.09375 -5.609375 L 5.15625 -5.578125 C 5.457031 -6.191406 5.8125 -6.59375 6.21875 -6.78125 C 6.625 -6.976562 7.191406 -7.078125 7.921875 -7.078125 L 8.453125 -7.078125 L 8.453125 -4.46875 L 7.921875 -4.46875 C 7.140625 -4.46875 6.546875 -4.332031 6.140625 -4.0625 C 5.734375 -3.800781 5.457031 -3.453125 5.3125 -3.015625 C 5.164062 -2.585938 5.09375 -2.113281 5.09375 -1.59375 L 5.09375 0 Z M 1.640625 0 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(81.662513, 22.137099)"><g><path d="M 5.015625 0 L 5.015625 -8.453125 C 5.015625 -9.109375 4.863281 -9.582031 4.5625 -9.875 C 4.257812 -10.175781 3.765625 -10.328125 3.078125 -10.328125 C 2.566406 -10.328125 2.097656 -10.253906 1.671875 -10.109375 C 1.242188 -9.972656 0.84375 -9.800781 0.46875 -9.59375 L 0.46875 -12.40625 C 0.8125 -12.5625 1.289062 -12.71875 1.90625 -12.875 C 2.53125 -13.03125 3.265625 -13.109375 4.109375 -13.109375 C 4.960938 -13.109375 5.71875 -12.984375 6.375 -12.734375 C 7.039062 -12.484375 7.566406 -12.066406 7.953125 -11.484375 C 8.335938 -10.898438 8.53125 -10.101562 8.53125 -9.09375 L 8.53125 0 Z M 5.015625 0 "/></g></g></g></svg>
				
				
				
				<svg height="20" viewBox="0 0 20 20" width="20" class="shopee-svg-icon _8tjJ2v">
					<g fill="none" fill-rule="evenodd" stroke="#fff" stroke-width="1.8" transform="translate(1 1)">
						<circle cx="9" cy="9" r="9"></circle>
						<path d="m11.5639648 5.05283203v4.71571528l-2.72832027 1.57129639" stroke-linecap="round" stroke-linejoin="round" transform="matrix(-1 0 0 1 20.39961 0)"></path>
					</g>
				</svg>
				<div class="FteIo2" style="font-weight: 500;" >จบใน</div>
				<div class="module-20-time">
				<count-down
								class="count-down"
								v-on:start_callback="countDownS_cb()"
								v-on:end_callback="countDownE_cb()"
								:currentTime="discountTimeMachine.currentTime"
								:startTime="discountTimeMachine.startTime"
								:endTime="discountTimeMachine.endTime"
								:dayTxt="'：'"
								:hourTxt="'：'"
								:minutesTxt="'：'"
								:secondsTxt="''"
							></count-down>
				</div>
			
				
				
				
				
				
				
				
				
				
					</div>
			
			
			
			
			
			
			
			
			
			
			
			
			
			
<div style="margin-top: 10px;"><div class="flex flex-column"><div class="flex flex-column _38g6so"><div class="flex items-center"><div class="flex items-center _34BHKe"><div class="_2yjfFH">฿{{ goodsSkuDetail.market_price }}</div><div class="flex items-center"><div class="_2Shl1j" style="    font-weight: 800;">฿{{ goodsSkuDetail.discount_price }}</div><div class="_3PlIlX">45% ส่วนลด</div></div></div></div></div></div></div>
			<div class="item-block">
				
				
				<div class="promotion-price">
					<dl class="item-line" style="display:none;">
						<dt class="ns-text-color-gray">ราคาสินค้า</dt>
						<dd>
							<em class="yuan ns-text-color">฿</em>
							<span class="price ns-text-color">{{ goodsSkuDetail.discount_price }}</span>
						</dd>
					</dl>
					<dl class="item-line" v-if="goodsSkuDetail.promotion_type == 1 && discountTimeMachine.currentTime" style="display:none;" >
						<dt class="ns-text-color-gray" >ลดจาก</dt>
						<dd>
							<em class="market-yuan">฿</em>
							<span class="market-price">{{ goodsSkuDetail.price }}</span>
						</dd>
					</dl>
					<dl class="item-line" v-if="goodsSkuDetail.member_price > 0">
						<dt class="ns-text-color-gray">ราคาสมาชิก</dt>
						<dd>
							<em class="market-yuan">฿</em>
							<span class="member_price">{{ goodsSkuDetail.member_price }}</span>
						</dd>
					</dl>
					<dl class="item-line" v-if="goodsSkuDetail.market_price > 0">
						<dt style="font-family: 'sukhumvittadmai2';" class="ns-text-color-gray">ราคา</dt>
						<dd>
							<em class="market-yuan">฿</em>
							<span class="market-price">{{ goodsSkuDetail.market_price }}</span>
						</dd>
					</dl>

					<div class="statistical"  style="    top: -76px;">
						<ul>
							<li>
								<p style="font-family: 'sukhumvittadmai2';     margin: 0rem 0;" >รีวิวสินค้า</p>
								<span style="font-family: 'sukhumvittadmai2'; ">{{ goodsSkuDetail.evaluate }}</span>
							</li>
							<li>
								<p style="font-family: 'sukhumvittadmai2';     margin: 0rem 0;" >ยอดขาย</p>
								<span style="font-family: 'sukhumvittadmai2';">{{ goodsSkuDetail.sale_num }} {{ goodsSkuDetail.unit }}</span>
							</li>
						</ul>
					</div>
					<dl class="item-line coupon-list" v-if="addonIsExit.coupon && couponList.length" style="    margin-top: 0px;">
						<dt style="font-family: 'sukhumvittadmai2';"  class="ns-text-color-gray">คูปอง</dt>
						<div>
							<dd>
								<p v-for="(item, index) in couponList" :key="index" class="ns-text-color" @click="receiveCoupon(item.coupon_type_id)" style="font-size:12px;">
									<span class="ns-border-color" v-if="item.type == 'discount'"  style="font-family: 'sukhumvittadmai2';">คูปอง {{ 100-(item.discount*10) }}%</span>
									<span class="ns-border-color" v-if="item.type == 'reward'"  style="font-family: 'sukhumvittadmai2';" >คูปอง ฿{{ item.money }}</span>
									<label v-if="item.type == 'discount'"  style="font-family: 'sukhumvittadmai2';">คูปอง -{{ 100-(item.discount*10) }}%</label>
									<label v-if="item.type == 'reward'"  style="font-family: 'sukhumvittadmai2';">คูปอง ฿{{ item.money }}</label>
								</p>
							</dd>
						</div>
					</dl>
					<dl class="item-line manjian" v-if="manjian.manjian" style="align-items: top; font-family: 'sukhumvittadmai2'; ">
						<dt>ลดเต็ม</dt>
						<dd>
							<i class="i-activity-flag ns-text-color ns-border-color">{{ manjian.manjian_name }}</i>
							<span>{{ manjian.manjian }}</span>
							<!-- <view class="item" v-if="manjian.manjian != undefined" style="display: flex;">
								<view class="free-tip color-base-text color-base-border">ลดเต็ม</view>
								<text class="font-size-base">{{ manjian.manjian }}</text>
							</view> -->
						</dd>
					</dl>
					<dl class="item-line manjian" v-if="manjian.mansong != undefined">
						<dt style="font-family: 'sukhumvittadmai2';" >กิจกรรมเสริม</dt>
						<dd style="display: flex;align-items: top;">
							<i class="i-activity-flag ns-text-color ns-border-color" style="    height: 25px;     line-height: 19px; margin-top: 5px;     font-family: sukhumvittadmai2;">{{ manjian.manjian_name }}</i>
							<div>
								{{ manjian.mansong }}
							</div>
						</dd>
					</dl>
					<dl class="item-line" v-if="goodsSkuDetail.is_virtual == 0">
						<dt style="font-family: 'sukhumvittadmai2';" >จัดส่ง</dt>
						<dd>
							<i class="i-activity-flag ns-text-color ns-border-color" style="font-family: 'sukhumvittadmai2';" v-if="goodsSkuDetail.is_free_shipping">จัดส่งฟรี</i>
							<i class="i-activity-flag ns-text-color ns-border-color"  style="font-family: 'sukhumvittadmai2';" v-else>การจัดส่งแบบปกติ</i>
						</dd>
					</dl>
					<!-- <div class="manjian-box">						
						<dl class="item-line manjian manjian-hide" v-if="addonIsExit.manjian && manjian.manjian_name">
							<dt>ลดเต็ม</dt>						
							<dd>					
								<i class="i-activity-flag ns-text-color ns-border-color">{{ manjian.manjian_name }}</i>						
								<span v-if="manjian.manjian"><i class="i-activity-flag ns-text-color ns-border-color">ลดเต็ม</i></span>
								<span v-if="manjian.mansong"><i class="i-activity-flag ns-text-color ns-border-color">จัดส่งเต็มรูปแบบ</i></span>
								<span v-if="manjian.free_shipping"><i class="i-activity-flag ns-text-color ns-border-color">จัดส่งฟรี</i></span>
							</dd>
							<span class="manjian-open">ขยายการโปรโมท<i class="el-icon-arrow-down"></i></span>
						</dl>
						<dl class="item-line manjian manjian-show" v-if="addonIsExit.manjian && manjian.manjian_name">
							<dt>ลดเต็ม</dt>						
							<dd>		
								<span v-if="manjian.manjian"><i class="i-activity-flag ns-text-color ns-border-color">ลดเต็ม</i>{{ manjian.manjian }}</span></br>
								<span v-if="manjian.mansong"><i class="i-activity-flag ns-text-color ns-border-color">จัดส่งเต็มรูปแบบ</i>{{ manjian.mansong }}</span></br>
								<span v-if="manjian.free_shipping"><i class="i-activity-flag ns-text-color ns-border-color">จัดส่งฟรี</i>{{ manjian.free_shipping }}</span>
							</dd>
						</dl>
					</div> -->
				</div>
			</div>
			<!-- <dl class="item-line" v-if="goodsSkuDetail.is_virtual == 0">
				<dt>ค่าขนส่ง</dt>
				<dd>
					<i class="i-activity-flag ns-text-color ns-border-color" v-if="goodsSkuDetail.is_free_shipping">จัดส่งฟรี</i>
					<i class="i-activity-flag ns-text-color ns-border-color" v-else>จัดส่งไม่ฟรีจากจดหมาย</i>
				</dd>
			</dl> -->
			<dl class="item-line delivery" v-if="goodsSkuDetail.is_virtual == 0">
				<dt style="font-family: 'sukhumvittadmai2';">สถานที่จัดส่ง</dt>
				<dd>
					<div class="region-selected ns-border-color-gray">
						<span>
							<template v-if="selectedAddress['level_1']">
								<template v-for="item in selectedAddress">
									{{ item.name }}
								</template>
							</template>
							<template v-else> โปรดเลือกที่อยู่จัดส่ง </template>
						</span>
						<i class="el-icon-arrow-down"></i>
					</div>

					<div class="region-list ns-border-color-gray" :class="{ hide: hideRegion }">
						<ul class="nav-tabs">
							<li :class="{ active: currTabAddres == 'province' }" @click="currTabAddres = 'province'">
								<div>
									<span>{{ selectedAddress["level_1"] ? selectedAddress["level_1"].name : "โปรดเลือกจังหวัด" }}</span>
									<i class="el-icon-arrow-down"></i>
								</div>
							</li>
							<li :class="{ active: currTabAddres == 'city' }" @click="currTabAddres = 'city'">
								<div>
									<span>{{ selectedAddress["level_2"] ? selectedAddress["level_2"].name : "โปรดเลือกเมือง" }}</span>
									<i class="el-icon-arrow-down"></i>
								</div>
							</li>
							<li :class="{ active: currTabAddres == 'district' }" @click="currTabAddres = 'district'">
								<div>
									<span>{{ selectedAddress["level_3"] ? selectedAddress["level_3"].name : "โปรดเลือกโซน/เขต" }}</span>
									<i class="el-icon-arrow-down"></i>
								</div>
							</li>
						</ul>
						<div class="tab-content">
							<div class="tab-pane" :class="{ active: currTabAddres == 'province' }">
								<ul class="province">
									<li v-for="(item, index) in provinceArr" :key="index" :class="{ selected: selectedAddress['level_' + item.level] && selectedAddress['level_' + item.level].id == item.id }">
										<span @click="getAddress('city', item)">{{ item.name }}</span>
									</li>
								</ul>
							</div>
							<div class="tab-pane" :class="{ active: currTabAddres == 'city' }">
								<ul class="city">
									<li v-for="(item, index) in cityArr" :key="index" :class="{ selected: selectedAddress['level_' + item.level] && selectedAddress['level_' + item.level].id == item.id }">
										<span @click="getAddress('district', item)">{{ item.name }}</span>
									</li>
								</ul>
							</div>
							<div class="tab-pane" :class="{ active: currTabAddres == 'district' }">
								<ul class="district">
									<li v-for="(item, index) in districtArr" :key="index" :class="{ selected: selectedAddress['level_' + item.level] && selectedAddress['level_' + item.level].id == item.id }">
										<span @click="getAddress('community', item)">{{ item.name }}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</dd>
			</dl>
			<dl class="item-line service">
				<dt style="font-family: 'sukhumvittadmai2';" >บริการ</dt>
				<dd>
					<span>
						เรา
						<span class="ns-text-color">{{siteInfo.site_name}}</span>
						บริการจัดส่งหลังการขาย
					</span>
				</dd>
			</dl>
			<hr class="divider" />
			<div class="sku-list" v-if="goodsSkuDetail.goods_spec_format">
				<dl class="item-line" v-for="(item, index) in goodsSkuDetail.goods_spec_format" :key="index">
					<dt>{{ item.spec_name }}</dt>
					<dd>
						<ul>
							<li v-for="(item_value, index_value) in item.value" :key="index_value">
								<div :class="{
                                        'selected ns-border-color': item_value['selected'] || skuId == item_value.sku_id,
                                        disabled: item_value['disabled'] || (!item_value['selected'] && specDisabled)
                                    }"
								 @click="changeSpec(item_value.sku_id, item_value.spec_id)">
									<img v-if="item_value.image" :src="$img(item_value.image, { size: 'small' })" />
									<span>{{ item_value.spec_value_name }}</span>
									<i class="iconfont iconduigou1 ns-text-color"></i>
								</div>
							</li>
						</ul>
					</dd>
				</dl>
			</div>

			<div class="buy-number">
				<dl class="item-line">
					<dt style="font-family: 'sukhumvittadmai2';" >ปริมาณ</dt>
					<dd>
						
							<el-input-number v-model="number" placeholder="0"  size="small" @input="keyInput()"></el-input-number>
							
						
						<span class="unit" style="padding-left: 15px; font-size: 15px;">{{ goodsSkuDetail.unit }}</span>
						<span class="inventory" style="font-size: 15px;">มีอยู่ <span style="font-weight: 700;">{{ goodsSkuDetail.stock }}</span> {{ goodsSkuDetail.unit }}</span>
						<!-- การซื้อแบบจํากัด -->
						<em v-if="goodsSkuDetail.is_limit==1" class="restrictions">
							<span v-if="goodsSkuDetail.limit_type==1">(การซื้อแบบจํากัด{{goodsSkuDetail.max_buy}}รายการ)</span> 
							<span v-else>(การซื้อมีจํานวนจํากัดต่อคน{{goodsSkuDetail.max_buy}}รายการ)</span> 
						</em>
					</dd>
				</dl>
			</div>

			<dl class="item-line buy-btn">
				<dt></dt>
				<dd v-if="goodsSkuDetail.goods_state == 1">
					<template v-if="goodsSkuDetail.stock == 0">
						<el-button type="info" plain disabled>สินค้าคงคลังไม่เพียงพอ</el-button>
					</template>
					
					<template v-else-if="goodsSkuDetail.max_buy != 0 && goodsSkuDetail.purchased_num >= goodsSkuDetail.max_buy">
						<el-button type="info" plain disabled>ถึงขีดจํากัดการซื้อสูงสุดแล้ว</el-button>
					</template>
					<template v-else>
						<el-button type="primary" style="font-family: 'sukhumvittadmai2';" plain @click="buyNow" >ซื้อตอนนี้</el-button>
						<el-button type="primary"  style="font-family: 'sukhumvittadmai2';" icon="el-icon-shopping-cart-2" v-if="goodsSkuDetail.is_virtual == 0" @click="joinCart" >หยิบใส่ตะกร้า</el-button>
					</template>
					<template v-else>
						<el-button type="info" plain disabled>ยังไม่วางขาย</el-button>
					</template>

					<div href="javascript:;" class="go-phone">
						<img src="@/assets/images/goods/qrcode.png" />
						<div class="qrcode-wrap"><img :src="qrcode" alt="รูปภาพรหัส QR" /></div>
					</div>
				</dd>

				<dd v-else>
					<template>
						<el-button type="info" plain disabled>ยังไม่วางขาย</el-button>
					</template>
					<div href="javascript:;" class="go-phone">
						<img src="@/assets/images/goods/qrcode.png" />
						<div class="qrcode-wrap"><img :src="qrcode" alt="รูปภาพรหัส QR" /></div>
					</div>
				</dd>
			</dl>
			<!-- shopInfo.shop_baozh == 1 || shopInfo.shop_qtian == 1 || shopInfo.shop_zhping == 1 || shopInfo.shop_erxiaoshi == 1 || shopInfo.shop_tuihuo == 1 || shopInfo.shop_shiyong == 1 || shopInfo.shop_shiti == 1 || shopInfo.shop_xiaoxie == 1 -->
			<dl class="item-line merchant-service" v-show="service_list.length">
				<dt>สินค้าและบริการ</dt>
				<div>
					<dd v-for="item in service_list">
						<i class="el-icon-success"></i>
						<span class="ns-text-color-gray" :title="item.service_name">{{item.service_name}}</span>
					</dd>
				</div>
			</dl>
		</div>

		<!-- ข้อมูลร้าน -->
		<!-- <div class="shop-wrap">
            <div class="head-wrap">
                <div class="img-wrap">
                    <img class="img-responsive center-block" :src="shopInfo.avatar ? $img(shopInfo.avatar) : $img(defaultShopImage)" @error="shopInfo.avatar = defaultShopImage" :alt="shopInfo.site_name" />
                </div>
                <h5>
                    <span class="site-name">{{ shopInfo.site_name }}</span>
                    <el-tag class="tag" size="small" v-if="shopInfo.is_own == 1">ดําเนินการด้วยตนเอง</el-tag>
                </h5>
            </div>
            <div class="info-wrap">
                <dl>
                    <dt class="site-score">การให้คะแนนร้านค้า</dt>
                    <dd><el-rate v-model="score" disabled></el-rate></dd>
                    <dt>รายละเอียดสินค้า：</dt>
                    <dd>
                        <span>{{ shopInfo.shop_desccredit }}</span>
                        แบ่ง
                    </dd>
                    <dt>บริการสําหรับผู้ขาย：</dt>
                    <dd>
                        <span>{{ shopInfo.shop_servicecredit }}</span>
                        แบ่ง
                    </dd>
                    <dt>ความเร็วในการจัดส่ง：</dt>
                    <dd>
                        <span>{{ shopInfo.shop_deliverycredit }}</span>
                        แบ่ง
                    </dd>
                </dl>
            </div>
            <div class="info-wrap" v-if="shopInfo.telephone">
                <dl>
                    <dt>เบอร์ติดต่อ：</dt>
                    <dd>{{ shopInfo.telephone }}</dd>
                </dl>
            </div>
            <div class="operation">
                <el-button class="btn btn-default" size="medium" @click="$router.pushToTab('shop-' + shopInfo.site_id)">เข้ามาและเดินไปรอบ ๆ</el-button>
                <el-button size="medium" @click="follow" v-if="hasFollow">เลิกติดตาม</el-button>
                <el-button size="medium" @click="follow" v-else>ติดตามร้านค้าของคุณ</el-button>
            </div>
        </div> -->

		<!-- แพ็คเกจรวม -->
		<el-tabs class="bundling-wrap" v-model="tabBundling" @tab-click="bundlingChange" v-if="addonIsExit.bundling && bundling.length && bundling[0].bl_name">
			<el-tab-pane :label="item.bl_name" :name="'bundling_' + item.bl_id" v-for="(item, index) in bundling" :key="index">
				<div class="master">
					<div class="sku-img"><img :src="$img(goodsSkuDetail.sku_image, { size: 'mid' })" /></div>
					<div class="sku-name">{{ goodsSkuDetail.sku_name }}</div>
					<div class="sku-price ns-text-color">฿{{ goodsSkuDetail.price }}</div>
					<i class="el-icon-plus"></i>
				</div>
				<div class="operation">
					<div class="price-wrap">
						<span>ราคารวม</span>
						<strong class="bl-price ns-text-color">฿{{ item.bl_price }}</strong>
					</div>
					<el-button type="primary" size="medium" @click="$router.pushToTab('promotion/combo-' + item.bl_id)">ซื้อตอนนี้</el-button>
					<i class="equal">=</i>
				</div>

				<div class="suits">
					<ul>
						<li v-for="(goods, goods_index) in item.bundling_goods" :key="goods_index" @click="$router.pushToTab({ path: '/sku-' + goods.sku_id })">
							<div class="sku-img"><img :src="$img(goods.sku_image, { size: 'mid' })" /></div>
							<div class="sku-name">{{ goods.sku_name }}</div>
							<div class="sku-price ns-text-color">฿{{ goods.price }}</div>
							
						</li>
					</ul>
				</div>
			</el-tab-pane>
		</el-tabs>
		
		

			
			
		<div class="detail-wrap">
			

			<el-tabs  class="goods-tab" v-model="tabName" @tab-click="tabChange">
				<el-tab-pane label="รายละเอียดสินค้า" name="detail">
					<div v-html="goodsSkuDetail.goods_content" style=""></div>
						<div class="empty animate__animated animate__fadeIn" v-if="goodsSkuDetail.goods_content==''" style="color: #898989;
    text-align: center;
    font-size: 14px;"><div class="el-empty" data-v-1ab1ffd8="">
   <div class="el-empty__image" style="width: 200px;">
      <img src="https://i.imgur.com/VrthEHO.png">
   </div>
   <div class="el-empty__description">
      <p style="font-family: 'sukhumvittadmai';">ไม่มีรายละเอียดสินค้า</p>
   </div>
   <!--v-if-->
</div></div>
				</el-tab-pane>
				
				<el-tab-pane label="แอตทริบิวต์ผลิตภัณฑ์" name="attr">
					<ul class="attr-list">
						<template v-if="goodsSkuDetail.goods_attr_format && goodsSkuDetail.goods_attr_format.length > 0">
							<li v-for="(item, index) in goodsSkuDetail.goods_attr_format" :key="index">{{ item.attr_name }}：{{ item.attr_value_name }}</li>
						</template>
					</ul>
				
				<div class="empty  animate__animated animate__fadeIn" v-if="goodsSkuDetail.goods_attr_format.length == 0" style="color: #898989;
    text-align: center;
    font-size: 14px;"><div class="el-empty" data-v-1ab1ffd8="">
   <div class="el-empty__image" style="width: 200px;">
      <img src="https://i.imgur.com/VrthEHO.png">
   </div>
   <div class="el-empty__description">
      <p style="font-family: 'sukhumvittadmai';">ไม่มี แอตทริบิวต์ผลิตภัณฑ์ นี้</p>
   </div>
   <!--v-if-->
</div></div>
				
				</el-tab-pane>
				<el-tab-pane v-if="evaluate_show" :label="evaluteCount.total ? 'รีวิวสินค้า(' + evaluteCount.total + ')' : 'รีวิวสินค้า'"
				 name="evaluate" class="evaluate">
					<template v-if="evaluteCount.total">
						<nav>
							<li :class="evaluaType == 0 ? 'selected' : ''" @click="evaluationType(0)">รีวิวทั้งหมด({{evaluteCount.total}})</li>
							<li :class="evaluaType == 1 ? 'selected' : ''" @click="evaluationType(1)">ยอดเยี่ยม({{evaluteCount.haoping}})</li>
							<li :class="evaluaType == 2 ? 'selected' : ''" @click="evaluationType(2)">ปลานกลาง({{evaluteCount.zhongping}})</li>
							<li :class="evaluaType == 3 ? 'selected' : ''" @click="evaluationType(3)">ไม่ค่อยดี({{evaluteCount.chaping}})</li>
						</nav>
						<ul class="list">
							<li v-for="(item, index) in goodsEvaluateList" :key="index">
								<div class="member-info">
								<img v-if="item.member_headimg==''" :src="'https://www.pngarts.com/files/11/Avatar-PNG-Download-Image.png'" @error="imageErrorEvaluate(index)" class="avatar" />
								<img v-else :src="$img(item.member_headimg)" @error="imageErrorEvaluate(index)" class="avatar" />
									<span>{{ item.member_name }}</span>
								</div>
								<div class="info-wrap">
									<el-rate v-model="item.star" disabled></el-rate>
									<p class="content">{{ item.content }}</p>
									<div class="img-list" v-if="item.images">
										<el-image v-for="(img, img_index) in item.images" :key="img_index" :src="$img(img)" :preview-src-list="item.imagesFormat"></el-image>
									</div>
									<div class="sku-info">
										<span>{{ item.sku_name }}</span>
										<span class="create-time">เวลาที่รีวิว :{{ $util.timeStampTurnTime(item.create_time) }}</span>
									</div>
									<div class="evaluation-reply" v-if="item.explain_first != ''">ร้านค้าตอบ：{{ item.explain_first }}</div>
									<template v-if="item.again_is_audit == 1 ">
										<div class="review-evaluation">
											<span>การประเมินเพิ่มเติม</span>
											<span class="review-time">{{ $util.timeStampTurnTime(item.again_time) }}</span>
										</div>
										<p class="content">{{ item.again_content }}</p>
										<div class="img-list">
											<el-image v-for="(again_img, again_index) in item.again_images" :key="again_index" :src="$img(again_img)"
											 :preview-src-list="item.againImagesFormat"></el-image>
										</div>
										<div class="evaluation-reply" v-if="item.again_explain != ''">ร้านค้าตอบ：{{ item.again_explain }}</div>
									</template>
								</div>
							</li>
						</ul>
						<div class="pager">
							<el-pagination background :pager-count="5" :total="total" prev-text="ก่อน" next-text="ต่อไป" :current-page.sync="currentPage"
							 :page-size.sync="pageSize" @size-change="handlePageSizeChange" @current-change="handleCurrentPageChange"
							 hide-on-single-page></el-pagination>
						</div>
					</template>
					<div class="empty animate__animated animate__fadeIn" v-else>  <div class="el-empty" data-v-1ab1ffd8="">
   <div class="el-empty__image" style="width: 200px;">
      <img src="https://i.imgur.com/VrthEHO.png">
   </div>
   <div class="el-empty__description">
      <p style="font-family: 'sukhumvittadmai';">ยังไม่มีรีวิวสินค้านี้</p>
   </div>
   <!--v-if-->
</div>
</div>
				</el-tab-pane>
				<template v-if="service">
					<el-tab-pane  v-if="service_is_display.is_display == 1" :label="service.title"  name="after_sale" class="after-sale"><div v-html="service.content"></div></el-tab-pane>
				</template>
			</el-tabs>
			
		</div>
		<div class="goods-recommended">
						<goods-recommend />
					</div>
		
		
		
		<!--ติดต่อหน้าต่างป็อปอัพบริการลูกค้า-->
		<servicerMessage ref="servicerMessage" class="kefu" :shop="{shop_id:shopInfo.site_id,logo:shopInfo.logo,shop_name:shopInfo.site_name}"></servicerMessage>
	</div>
</template>

<script>
	import PicZoom from "vue-piczoom";
	import detail from "./detail";
	import GoodsRecommend from "@/components/GoodsRecommend";
	import servicerMessage from "@/components/message/servicerMessage";
	export default {
		name: "detail",
		components: {
			PicZoom,
			GoodsRecommend,
			servicerMessage
		}, 
		mixins: [detail]
	}
</script>
<style lang="scss">
	@import "./detail.scss";
	.goods-detail .basic-info-wrap .item-line dt {
	    display: inline-block;
	    width: 100px;
	    height: 35px;
	    line-height: 35px;
	    text-align: justify;
	    padding-left: 16px;
	    font-size: 12px;
	    margin-right: 16px;
	    color: #838383;
	    flex-shrink: 0;
	}
	.goods-detail .basic-info-wrap .item-block {
	    background: #a52a2a00;
	 
	    border-radius: 0px;
	    padding: 9px 0;
	    position: relative;
	    background-size: cover;
	    min-height: 62px;
	}a{text-decoration:none;color:#303133;}
a:hover{color:#FE2F2F;}
a{background-color:transparent;}
*{-webkit-overflow-scrolling:touch;}
*{box-sizing:border-box;outline:none;}
a{color:#0074c2;}
::-moz-selection{background:#b3d4fc;text-shadow:none;}
::selection{background:#b3d4fc;text-shadow:none;}
@media print{
*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important;}
a,a:visited{text-decoration:underline;}
a[href]:after{content:" (" attr(href) ")";}
}
a{background-color:transparent;}
*{-webkit-overflow-scrolling:touch;}
*{box-sizing:border-box;outline:none;}
a{color:#0074c2;}
::-moz-selection{background:#b3d4fc;text-shadow:none;}
::selection{background:#b3d4fc;text-shadow:none;}
@media print{
*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important;}
a,a:visited{text-decoration:underline;}
a[href]:after{content:" (" attr(href) ")";}
}
/*! CSS Used from: Embedded */
a{text-decoration:none;color:#303133;}
a:hover{color:#FE2F2F;}
/*! CSS Used from: Embedded */
a{text-decoration:none;color:#303133;}
a:hover{color:#FE2F2F;}
a{text-decoration:none;color:#303133;}
a:hover{color:#FE2F2F;}
/*! CSS Used from: Embedded */
a{text-decoration:none;color:#303133;}
a:hover{color:#FE2F2F;}
a{text-decoration:none;color:#303133;}
a:hover{color:#FE2F2F;}
/*! CSS Used from: Embedded */
a{text-decoration:none;color:#303133;}
a:hover{color:#FE2F2F;}
/*! CSS Used from: Embedded */
a[data-v-eea730d8]{text-decoration:none;color:#303133;}
a[data-v-eea730d8]:hover{color:#FE2F2F;}
.padd-10[data-v-eea730d8]{padding:0 10px;}
.search_bread[data-v-eea730d8]{display:inline-block;font-size:14px;margin:0px auto;width:100%;padding:10px;}
@media all{
*[data-v-eea730d8],[data-v-eea730d8]::after,[data-v-eea730d8]::before{box-sizing:border-box;}
a[data-v-eea730d8]{color:#007bff;text-decoration:none;background-color:transparent;}
a[data-v-eea730d8]:hover{color:#0056b3;text-decoration:underline;}
}
@media print{
*[data-v-eea730d8],[data-v-eea730d8]::after,[data-v-eea730d8]::before{text-shadow:none!important;box-shadow:none!important;}
a[data-v-eea730d8]:not(.btn){text-decoration:underline;}
}
@media all{
a[data-v-eea730d8]{background-color:transparent;}
a[data-v-eea730d8]:active,a[data-v-eea730d8]:hover{outline:0;}
*[data-v-eea730d8],*[data-v-eea730d8]:before,*[data-v-eea730d8]:after{box-sizing:border-box;}
a[data-v-eea730d8],a[data-v-eea730d8]:hover{text-decoration:none;}
}
@media all{
a[data-v-eea730d8]{color:#3f4d56;transition:300ms;}
}
@media all{
*[data-v-eea730d8]:not(body){-webkit-tap-highlight-color:transparent;-ms-overflow-style:none;scrollbar-width:none;}
div[data-v-eea730d8],span[data-v-eea730d8]{border:0;margin:0;padding:0;}
a[data-v-eea730d8]{border:0;font-size:100%;vertical-align:baseline;margin:0;padding:0;}

a[data-v-eea730d8]{cursor:pointer;}
a[data-v-eea730d8]{text-decoration:none;color:#1B1B1B;}
[data-v-eea730d8]:focus{outline:0;}
a[data-v-eea730d8],span[data-v-eea730d8],div[data-v-eea730d8]{font-family:"sukhumvittadmai", sans-serif;}
}
/*! CSS Used fontfaces */
@font-face{font-family:"sukhumvittadmai";src:url(https://overmine.org/SukhumvitTadmai-Text.ttf) format("truetype");}

.el-tabs__item {
    padding: 0 20px;
    font-weight: 500;
    font-family: 'sukhumvittadmai2';
    height: 40px;
    box-sizing: border-box;
    line-height: 40px;
    display: inline-block;
    list-style: none;
    font-size: 15px;
    color: #303133;
    position: relative;
}.goods-detail .basic-info-wrap h1 {
    font-size: 23px;
    font-family: 'sukhumvittadmai2';
        margin: 0px 0px 0px 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}.goods-detail .basic-info-wrap .item-line.delivery {
     margin:0px 0px 0px 0px;
}.goods-detail .basic-info-wrap {
    float: left;
    width: calc(100% - 431px - 40px);
    margin-left: 20px;
}.goods-detail .preview-wrap .magnifier-wrap {
    width: 450px;
    height: 450px;
    border: 1px solid #e9e9e9;
    box-sizing: border-box;
}/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg//assets/bundle.e6bc39cd9ab056c6.css */
.flex{display:flex;}
.flex-column{flex-direction:column;}
.items-center{align-items:center;}
/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/productdetailspage/pcmall-productdetailspage.491318d6c9b0c89b573d.legacy.css */
._34BHKe{flex-wrap:wrap;width:625px;flex-basis:625px;min-height:1.875rem;}
._2yjfFH{font-size:1rem;text-decoration:line-through;color:#929292;margin-right:10px;}
._2Shl1j{font-size:1.875rem;font-weight:500;color:#ee4d2d;}
.theme--ofs ._2Shl1j{color:#d0011b;}
._3PlIlX{margin-left:15px;font-size:.75rem;color:#fff;text-transform:uppercase;background:#ee4d2d;border-radius:2px;padding:2px 4px;font-weight:600;line-height:1;white-space:nowrap;}
.theme--ofs ._3PlIlX{background-color:#d0011b;}
._38g6so{padding: 15px 20px;
    background: url(https://x.dscmall.cn/themes/ecmoban_dsc2017/images/summary-bg.jpg);}._2Shl1j {
    font-size: 1.875rem;
    font-weight: 500;
    color: #fe2f2f;
}._3PlIlX {
    margin-left: 15px;
    font-size: 0.75rem;
    color: #fff;
    text-transform: uppercase;
    background: #fe2f2f;
    border-radius: 2px;
    padding: 2px 4px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
}.goods-detail .detail-wrap .goods-tab {
    margin-left: 0px;
}/*! CSS Used from: https://element-plus.org/assets/style.c017d434.css */
p{font-size:inherit;}
p{line-height:1.8;}
p:first-child{margin-top:0;}
p:last-child{margin-bottom:0;}
.el-empty{--el-empty-padding:40px 0;--el-empty-image-width:160px;--el-empty-description-margin-top:20px;--el-empty-bottom-margin-top:20px;--el-empty-fill-color-0:var(--el-color-white);--el-empty-fill-color-1:#fcfcfd;--el-empty-fill-color-2:#f8f9fb;--el-empty-fill-color-3:#f7f8fc;--el-empty-fill-color-4:#eeeff3;--el-empty-fill-color-5:#edeef2;--el-empty-fill-color-6:#e9ebef;--el-empty-fill-color-7:#e5e7e9;--el-empty-fill-color-8:#e0e3e9;--el-empty-fill-color-9:#d5d7de;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;box-sizing:border-box;padding:var(--el-empty-padding);}
.el-empty__image{width:var(--el-empty-image-width);}
.el-empty__image svg{color:var(--el-svg-monochrome-grey);fill:currentColor;width:100%;height:100%;vertical-align:top;}
.el-empty__description{margin-top:var(--el-empty-description-margin-top);}
.el-empty__description p{margin:0;font-size:var(--el-font-size-base);color:var(--el-text-color-secondary);}
*,:before,:after{box-sizing:border-box;}
p{margin:1rem 0;line-height:1.7;}
*{scrollbar-color:var(--el-scrollbar-bg-color) var(--el-fill-color-light);}
::-webkit-scrollbar{width:6px;}
::-webkit-scrollbar-track{border-radius:10px;}
::-webkit-scrollbar-thumb{background-color:#0003;border-radius:10px;transition:all .2s ease-in-out;}
::-webkit-scrollbar-thumb:hover{cursor:pointer;background-color:#0000004d;}
[fill~="none"]{fill:none;}





span{
	    font-family: 'Prompt' !important;
}.hO9GFq {
		color: #fff;
	}
	
	.hO9GFq {
		display: flex;
		align-items: center;
		margin-top: .625rem;
		height: 36px;
		padding: 0 20px;
		background-image: url(https://shop.phawhale.com/upload/1/common/images/20221209/20221209013115167056747566521_BIG.png?time=1670567477), linear-gradient(-90deg, #f0451e 9%, #f32424 96%);
		    background-size: cover;
	}
	
	.FteIo2 {
		text-transform: uppercase;
		margin-right: .625rem;
		font-weight: lighter;
	}
	
	._8tjJ2v {
		width: 17px;
		height: 17px;
		margin-left: auto;
		margin-right: 6px;
	}
	
	.Kg2R-S {
		font-size: 1rem;
		text-decoration: line-through;
		color: #929292;
		margin-right: 10px;
	}
	
	.X0xUb5 {
		font-size: 1.875rem;
		font-weight: 500;
		color: #ee4d2d;
	}
	
	.theme--ofs .X0xUb5 {
		color: #d0011b;
	}
	
	.\+1IO\+x {
		margin-left: 15px;
		font-size: .75rem;
		color: #fff;
		text-transform: uppercase;
		background: #ee4d2d;
		border-radius: 2px;
		padding: 2px 4px;
		font-weight: 600;
		line-height: 1;
		white-space: nowrap;
	}
	
	.theme--ofs .\+1IO\+x {
		background-color: #d0011b;
	}
	
	._9GxTz3 {
		flex-wrap: wrap;
		width: 625px;
		flex-basis: 625px;
		min-height: 1.875rem;
	}
	
	.LR5fT5 {
		padding: 15px 20px;
		background: #fafafa;
	}
	
	
	/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/voucher/573.6f2c85ba2352c7f1c9c0.legacy.css */
	
	.stardust-icon {
		stroke: currentColor;
		fill: currentColor;
		width: 1em;
		height: 1em;
	}
	
	
	/*! CSS Used from: https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/productdetailspage/1545.de836f8ab95af45532cc.legacy.css */
	
	.flex {
		display: flex;
	}
	
	
	/*! CSS Used keyframes */
	
	@-webkit-keyframes second-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@keyframes second-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@-webkit-keyframes second-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@keyframes second-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@-webkit-keyframes second-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@keyframes second-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@-webkit-keyframes second-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		15% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		31.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		48.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		65% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		81.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		98.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@keyframes second-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		15% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		31.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		48.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		65% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		81.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		98.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@-webkit-keyframes second-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		15% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		31.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		48.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		65% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		81.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		98.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@keyframes second-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		15% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		31.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		48.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		65% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		81.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		98.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@-webkit-keyframes second-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		15% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		31.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		48.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		65% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		81.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		98.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@keyframes second-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		15% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		31.66% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		48.33% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		65% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		81.66% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		98.33% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@-webkit-keyframes minute-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		9.833% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		19.833% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		29.833% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		39.833% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		49.833% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		59.833% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		69.833% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		79.833% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		89.833% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		99.833% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@keyframes minute-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		9.833% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		19.833% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		29.833% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		39.833% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		49.833% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		59.833% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		69.833% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		79.833% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		89.833% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		99.833% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@-webkit-keyframes minute-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		9.833% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		19.833% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		29.833% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		39.833% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		49.833% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		59.833% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		69.833% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		79.833% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		89.833% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		99.833% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@keyframes minute-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		9.833% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		19.833% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		29.833% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		39.833% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		49.833% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		59.833% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		69.833% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		79.833% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		89.833% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		99.833% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@-webkit-keyframes minute-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		9.833% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		19.833% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		29.833% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		39.833% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		49.833% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		59.833% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		69.833% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		79.833% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		89.833% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		99.833% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@keyframes minute-digit {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		9.833% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		19.833% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		20% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		29.833% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		30% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		39.833% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		40% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		49.833% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		50% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		59.833% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		60% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		69.833% {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
		70% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		79.833% {
			-webkit-transform: translateY(-119px);
			transform: translateY(-119px);
		}
		80% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		89.833% {
			-webkit-transform: translateY(-136px);
			transform: translateY(-136px);
		}
		90% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		99.833% {
			-webkit-transform: translateY(-153px);
			transform: translateY(-153px);
		}
		to {
			-webkit-transform: translateY(-170px);
			transform: translateY(-170px);
		}
	}
	
	@-webkit-keyframes minute-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.638888% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.666666% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.305555% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.333333% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		49.972222% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.638888% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.666666% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.305555% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.333333% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		99.972222% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@keyframes minute-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.638888% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.666666% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.305555% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.333333% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		49.972222% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.638888% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.666666% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.305555% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.333333% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		99.972222% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@-webkit-keyframes minute-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.638888% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.666666% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.305555% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.333333% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		49.972222% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.638888% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.666666% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.305555% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.333333% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		99.972222% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@keyframes minute-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.638888% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.666666% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.305555% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.333333% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		49.972222% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.638888% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.666666% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.305555% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.333333% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		99.972222% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@-webkit-keyframes minute-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.638888% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.666666% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.305555% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.333333% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		49.972222% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.638888% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.666666% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.305555% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.333333% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		99.972222% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	
	@keyframes minute-ten {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.638888% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		16.666666% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.305555% {
			-webkit-transform: translateY(-17px);
			transform: translateY(-17px);
		}
		33.333333% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		49.972222% {
			-webkit-transform: translateY(-34px);
			transform: translateY(-34px);
		}
		50% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.638888% {
			-webkit-transform: translateY(-51px);
			transform: translateY(-51px);
		}
		66.666666% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.305555% {
			-webkit-transform: translateY(-68px);
			transform: translateY(-68px);
		}
		83.333333% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		99.972222% {
			-webkit-transform: translateY(-85px);
			transform: translateY(-85px);
		}
		to {
			-webkit-transform: translateY(-102px);
			transform: translateY(-102px);
		}
	}
	.count-down span{display:inline-block !important;
	width:22px !important;
	height:22px !important;
	line-height:22px !important;
	text-align:center !important;
	background:#383838 !important;
	color:#ffffff !important;
	border-radius:2px !important; }
	
	
	.vjs-icon-volume-high, .video-js .vjs-mute-control .vjs-icon-placeholder {
	    font-family: VideoJS !important;
	 
	}
	.vjs-icon-play, .video-js .vjs-play-control .vjs-icon-placeholder, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
	    font-family: VideoJS !important;
	
	}.vjs-icon-fullscreen-enter, .video-js .vjs-fullscreen-control .vjs-icon-placeholder {
    font-family: VideoJS!important;

}
</style>
